var React = require('react');

function IconRadioButtonInactiveInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.5,0 C17.8512746,0 23,5.14872538 23,11.5 C23,17.8512746 17.8512746,23 11.5,23 C5.14872538,23 0,17.8512746 0,11.5 C0,5.14872538 5.14872538,0 11.5,0 Z M11.5,2 C6.25329488,2 2,6.25329488 2,11.5 C2,16.7467051 6.25329488,21 11.5,21 C16.7467051,21 21,16.7467051 21,11.5 C21,6.25329488 16.7467051,2 11.5,2 Z"}));
}

IconRadioButtonInactiveInline.defaultProps = {"viewBox":"0 0 23 23"};

module.exports = IconRadioButtonInactiveInline;

IconRadioButtonInactiveInline.default = IconRadioButtonInactiveInline;
